import * as actions from "./actionsTypes";

const initialData = {
  loaderTrainingAssistance: false,
  trainingAssistance: null,
  trainingAssistanceAll: null,
  trainingAssistanceFail: null,
  saveLoaderTrainingAssistance: false,
  trainingAssistanceFormError: null,

  loaderTrainingAssistance_correo_Facilitador: false,
  trainingAssistance_correo_Facilitador: null,
  trainingAssistanceAll_correo_Facilitador: null,
  trainingAssistanceFail_correo_Facilitador: null,
  saveLoaderTrainingAssistance_correo_Facilitador: false,
  trainingAssistanceFormError_correo_Facilitador: null,

  loaderTrainingAssistanceUpload: false,
  trainingAssistanceUploadFail: null,
  trainingAssistanceUploadProblems: [],
};

export default function TrainingAssistanceReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_TRAINING_ASSISTANCE:
      return { ...state, loaderTrainingAssistance: action.payload };

    case actions.GET_TRAINING_ASSISTANCE:
      return {
        ...state,
        trainingAssistance: action.payload.trainingAssistance,
        trainingAssistanceAll: action.payload.trainingAssistanceAll,
      };

    case actions.GET_TRAINING_ASSISTANCE_CORREO_FACILITADOR:
      return {
        ...state,
        trainingAssistance_correo_Facilitador: action.payload,
      };

    case actions.TRAINING_ASSISTANCE_FAIL:
      return { ...state, trainingAssistanceFail: action.payload };

    case actions.TRAINING_ASSISTANCE_FAIL_CORREO_FACILITADOR:
      return {
        ...state,
        trainingAssistanceFail_correo_Facilitador: action.payload,
      };

    case actions.SAVE_LOADER_TRAINING_ASSISTANCE:
      return { ...state, saveLoaderTrainingAssistance: action.payload };

    case actions.SAVE_LOADER_TRAINING_ASSISTANCE_CORREO_FACILITADOR:
      return {
        ...state,
        saveLoaderTrainingAssistance_correo_Facilitador: action.payload,
      };

    case actions.FORM_TRAINING_ASSISTANCE_FAIL:
      return { ...state, trainingAssistanceFormError: action.payload };

    case actions.FORM_TRAINING_ASSISTANCE_FAIL_CORREO_FACILITADOR:
      return {
        ...state,
         trainingAssistanceFormError_correo_Facilitador: action.payload,
      };

    case actions.LOADER_TRAINING_ASSISTANCE_UPLOAD:
      return { ...state, loaderTrainingAssistanceUpload: action.payload };

    case actions.GET_TRAINING_ASSISTANCE_UPLOAD:
      return {
        ...state,
        trainingAssistance: action.payload.trainingAssistance,
        trainingAssistanceAll: action.payload.trainingAssistanceAll,
      };

    case actions.TRAINING_ASSISTANCE_UPLOAD_FAIL:
      return { ...state, trainingAssistanceUploadFail: action.payload };

    case actions.TRAINING_ASSISTANCE_UPLOAD_PROBLEMS:
      return { ...state, trainingAssistanceUploadProblems: action.payload };

    default:
      return state;
  }
}
